const state = {
    uid: null,
    email: null,
    firstName: null,
    lastName: null,
    loginStatus: false,
    role: null
}

const mutations = {

    setUID(state, uid) {
        state.uid = uid;
    },

    setEmail(state, email) {
        state.email = email;
    },

    setLoginStatus(state, loginStatus) {
        state.loginStatus = loginStatus;
    },

    setRole(state, role) {
        state.role = role;
    },

    setFirstName(state, firstName) {
        state.firstName = firstName;
    },

    setLastName(state, lastName) {
        state.lastName = lastName;
    },

    logout(state) {
        state.uid = null;
        state.firstName = null;
        state.lastName = null;
        state.email = null;
        state.loginStatus = false;
        state.role = null;
    }
}

const getters = {

}

const actions = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}